import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { DataSubcodes } from '../../../services/errors/consts'
import { isDataError } from '../../../services/errors/utils'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'

const dataApi = DataApi.getInstance()

type MutationParams = {
  uuid: string
}

export default function useRemoveEventPattern() {
  const queryClient = useQueryClient()
  const texts = useTranslation().t

  const mutation = useMutation((data: MutationParams) => dataApi.removeEventPattern(data.uuid), {
    onError: (error: AxiosError<HttpError>) => {
      if (isDataError(error, [DataSubcodes.EVENT_PATTERN_NOT_FOUND, DataSubcodes.EVENT_PATTERN_REMOVED])) {
        queryClient.resetQueries([queryNames.getEventPatternList])
      }
      showErrorToast(error, texts)
    },
    onSuccess: () => {
      queryClient.resetQueries([queryNames.getEventPatternList])
      queryClient.resetQueries([queryNames.getEventList])
      toast.success(texts('successes:event_pattern_removed'))
    }
  })

  return mutation
}
